export const fullwidthTohalfWidth = <T extends string | null | undefined>(
  value: T,
): T => {
  if (value == null) {
    return value;
  }

  return value.replace(/[０-９]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xfee0),
  ) as T;
};

export const normalizesDashedNumber = <T extends string | null | undefined>(
  value: T,
): T => {
  if (value == null) {
    return value;
  }

  return value
    .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
    .replace(/[ー\-−―‐ｰ－]/g, "-") as T;
};

export const normalizeNumber = (
  value: string | null | undefined | number,
): number | null | undefined => {
  if (value == null) {
    return value;
  }

  return parseInt(
    value
      .toString()
      .replace(/[０-９]/g, (s) =>
        String.fromCharCode(s.charCodeAt(0) - 0xfee0),
      ),
  );
};
